import React from 'react';

import HouseType from '../sections/HouseType';
import NewAddress from '../sections/NewAddress';
import StartDate from '../sections/StartDate';
import NewContract from '../sections/NewContract';
import ExtraServices from '../sections/ExtraServices';
import Billing from '../sections/Billing';
import MultipleOwners from '../sections/MultipleOwners';

export const New: React.FunctionComponent = () => {
  return (
    <>
      <NewAddress />
      <HouseType />
      <NewContract />
      <StartDate />
      <ExtraServices />
      <Billing />
      <MultipleOwners />
    </>
  );
};

export default New;
